<template>
  <el-dropdown>
    <span class="el-dropdown-link">
      Report Action<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2)">PDF</el-dropdown-item>
      <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1)">XL</el-dropdown-item>
      <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3)">Sent to Email</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import notification from '@/notification/notification.js'


  export default {
    data() {
      return {
        moment:moment,
        type: {
          general: 16,
          templates: 17,
          deleted: 20,
          voidEntries: 21,
          cashReceipts: 24,
          cashDisbursements: 15,
          journalReport: 18
        }
      }
    },
    props: {
      activeTab: {
        type: String,
        required: true
      },
      filterBy: {
        type: Object,
        default: null
      },
      filterValue: {
        type: Object,
        default: null
      },
      period: {
        type: [Array, null],
        default: null
      },
    },
    methods: {
      async exportData (typeExportId) {
        let loader = this.$loading.show()
        let email = null
        try {
          if (typeExportId === 3) {
            loader.hide()
            const { value } = await this.$prompt('Please input your e-mail', '', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
              inputErrorMessage: 'Invalid Email'
            })
            email = value
            notification({title: 'Success', message: 'Sent to email', type: 'success'})
          }
          let startDate = (this.period && this.period.length > 0) ? this.period[0] : null
          let endDate = (this.period && this.period.length > 0) ? this.period[1] : null
          const payload = {
            companyId: +this.$route.query.companyId,
            typeExportId: typeExportId,
            typeId: this.setTypeId(),
            startDate: startDate ? moment(startDate, 'x').format('YYYY-MM-DD') : null,
            endDate: endDate ? moment(endDate, 'x').format('YYYY-MM-DD') : null,
            email: email,
            optionalField: {
              name: 'typeReport',
              value: null
            },
            filterBy: this.filterBy,
            filterValue: JSON.parse(this.filterValue),
            orderBy: null,
            order: null
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          axios.defaults.headers.common['X-Timezone-Offset'] = (new Date().getTimezoneOffset() / 60).toString()
          const { data } = await  axios.post(`/api/v1/export`, payload)
          switch (typeExportId) {
            case 2: // pdf
            case 1: // xl
              window.open(data.file.downloadPath).focus()
              break
          }
        } catch (err) {
          console.log(err)
        } finally {
          loader.hide()
        }
      },
      setTypeId() {
        return this.type[this.activeTab]
      }
    },
  }
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
</style>